export default {
  main: {
    site_id: 1865769,
    websitePasswordHash: '36aeec3df5c6d3e9e8701ec60dcf94a6ce5833a8d331b52b93303c55c1455832',
    availableLanguages: {
      '@replace': true,
      rus: {
        short: 'RU',
        name: 'Rus',
        region: 'Russia',
        order: 2,
      },
      eng: {
        short: 'EN',
        name: 'Eng',
        region: 'UnitedKingdom',
        order: 2,
      },
    },
    terminalMode: 'clientTransaction',
    logoSize: 'big',
    useCurrencySymbol: false,
  },
  defaultTerminalParams: {
    pid: 1057,
    tid: 16066,
    token: 'PJDBHQ==',
    currency: 'UZS'
  },
  clientTransaction: {
    enableClientWithdraw: false,
    rightSideResize: true,
    enableTransactionWithoutAdmin: true,
  },
  env: {
    lang: 'rus',
  },
  dailyReportUnitsToShow: ['deposit'],
  lastTicketButtons: [
    {
      name: 'Deposit tickets',
      type: 'clientDepositTicket',
      hideOnRestrictMode: false,
    },
  ],
  financialButtons: [
    {
      type: 'dailyReport',
      name: 'Daily report',
    },
    {
      type: 'lastBills',
      name: 'Last bills',
    },
  ],
  routes: [
    {
      url: 'clientTransaction',
      enabled: true,
    },
  ],
};
